"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DcVppVehicleUsage = exports.VppVehicleUsage = exports.VppInventoryType = exports.VppDealType = void 0;
var VppDealType;
(function (VppDealType) {
    VppDealType["CASH"] = "Cash";
    VppDealType["FINANCE"] = "Finance";
    VppDealType["LEASE"] = "Lease";
})(VppDealType = exports.VppDealType || (exports.VppDealType = {}));
var VppInventoryType;
(function (VppInventoryType) {
    VppInventoryType["CPO"] = "CertifiedPreOwned";
    VppInventoryType["NEW"] = "New";
    VppInventoryType["USED"] = "Used";
})(VppInventoryType = exports.VppInventoryType || (exports.VppInventoryType = {}));
var VppVehicleUsage;
(function (VppVehicleUsage) {
    VppVehicleUsage["PERSONAL"] = "Personal";
    VppVehicleUsage["COMMERCIAL"] = "Commercial";
})(VppVehicleUsage = exports.VppVehicleUsage || (exports.VppVehicleUsage = {}));
var DcVppVehicleUsage;
(function (DcVppVehicleUsage) {
    DcVppVehicleUsage["AGRICULTURAL"] = "Agricultural";
    DcVppVehicleUsage["BUSINESS"] = "Business";
    DcVppVehicleUsage["PERSONAL"] = "Personal";
})(DcVppVehicleUsage = exports.DcVppVehicleUsage || (exports.DcVppVehicleUsage = {}));
